import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import UserCard from '@components/ConnectionCard';
import CommunityActions from '~/actions/community';

const People = ({ connections }) => {
    const dispatch = useDispatch();

    const handleOpenDetail = (connect) => () => {
        const { user_id, slug } = connect.connector;
        const payload = { userId: user_id };
        dispatch(CommunityActions.getcommunityuserRequest(payload, null, `/${slug}/about`));
    };

    return (
        <Row className="connections-people mx-1">
            {connections.map((connection) => (
                <Col key={connection.id} className="p-2" xs={12} sm={6} md={3}>
                    <UserCard tab="people" data={connection} onOpen={handleOpenDetail(connection)} />
                </Col>
            ))}
            {connections.length === 0 && <p className="dsl-b16 p-3">No people</p>}
        </Row>
    );
};

People.propTypes = {
    connections: PropTypes.array,
};

People.defaultProps = {
    connections: [],
};

export default People;
